import { Model_Datasource, AbsPaginatedGrid } from 'src/app/app.models';

export abstract class DatasourceOfflineDao {
    abstract doSyncDatasourcesAction(_datasources: Model_Datasource[]): Promise<void>;
    abstract doClearDatasourcesAction(): Promise<void>;
    abstract doGetDatasourcesAction(): Promise<Model_Datasource[]>;
    abstract doInsertDatasourcesAction(_datasources: Model_Datasource[]): Promise<void>;
    abstract doSaveDatasourceAction(_datasource: Model_Datasource): Promise<Model_Datasource>;
    abstract doGetDatasourceAction(_numDatasource: string): Promise<Model_Datasource>;
    abstract doBuildDatasourceByNumAction(_num: string): Promise<AbsPaginatedGrid<any>>;
}